export default "/images/6774f01e7589ad885804dfb9d75b3464.avif";